export default __webpack_public_path__ + "static/media/sounds/click_ok_alyx.mp3";